"use client"

import {useEffect} from "react";

const GoogleAds = () => {
    useEffect(() => {
        if (typeof window.gtag !== 'undefined') {
            window.gtag('config', 'AW-712734607');
        }
    })
};

export default GoogleAds;